<template>
  <div class="click-control">
    <div ref="selector" class="selector" :class="{'selector--visible' : cursorState === 'selector'}">
      <div class="selector__left-corner" />
      <div class="selector__middle" />
      <div class="selector__right-corner" />
      <div class="selector-item selector-item--previous"
           :class="{
             'selector-item--disabled' : currentPreviewIndex === 1,
             'selector-item--visible' : isSelectorVisible
           }"
      >
        <i class="fas fa-arrow-left" />
      </div>
      <div class="selector-item selector-item--next"
           :class="{
             'selector-item--disabled' : currentPreviewIndex === previewBackgroundTexts.length,
             'selector-item--visible' : isSelectorVisible
           }"
      >
        <i class="fas fa-arrow-right" />
      </div>
      <div ref="indicator" class="selector-indicator">
        <div ref="left"
             class="selector-item selector-item--clipped selector-item--previous"
             :class="{'selector-item--forbidden' : currentPreviewIndex === 1}"
        >
          <i v-if="currentPreviewIndex === 1" class="fas fa-ban" />
          <i v-else class="fas fa-arrow-left" />
        </div>
        <div ref="right"
             class="selector-item selector-item--clipped selector-item--next"
             :class="{'selector-item--forbidden' : currentPreviewIndex === previewBackgroundTexts.length}"
        >
          <i v-if="currentPreviewIndex === previewBackgroundTexts.length" class="fas fa-ban" />
          <i v-else class="fas fa-arrow-right" />
        </div>
      </div>
    </div>
    <div ref="cursor"
         class="cursor"
         :class="`cursor--${cursorState}`"
    >
      <div class="cursor__bg" />
      <div class="target">
        <div class="target__x" />
        <div class="target__y" />
      </div>
      <font-awesome-icon icon="hand-pointer" class="interaction-icon" :class="{'interaction-icon--visible' : cursorState === 'pointer'}" />
      <font-awesome-icon icon="i-cursor" class="interaction-icon" :class="{'interaction-icon--visible' : cursorState === 'text'}" />
    </div>
    <div
      v-if="!didShowSelectorPresenter"
      ref="presenter"
      class="selector-feature-presenter"
      :class="{'selector-feature-presenter--disabled' : isSelectorPresenterDisabled}"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 183 90.71">
        <g class="speech-bubble">
          <polyline
            class="speech-bubble__left"
            :class="{'speech-bubble__left--visible' : isSelectorPresenterVisible}"
            points="26,90 18,82 1,82 1,0 1,82 18,82 26,90 "
          />
          <polyline
            class="speech-bubble__right"
            :class="{'speech-bubble__right--visible' : isSelectorPresenterVisible}"
            points="25,90 33,82 183,82 33,82 25,90 "
          />
        </g>
      </svg>
      <div class="presenter-text">
        <h4 class="presenter-text__title" :class="{'presenter-text__title--visible' : isSelectorPresenterVisible}">
          Você gosta de atalhos?
        </h4>
        <p class="presenter-text__text" :class="{'presenter-text__text--visible' : isSelectorPresenterVisible}">
          Clique, segure e arraste num espaço vazio para navegar rapidamente entre projetos
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

const TWO_PREVIEWS = 2

export default {
  name: 'CustomCursor',
  data () {
    return {
      selectorOffset: undefined,
      indicatorTransform: undefined,
      isSelectorStatic: false,
      isSelectorVisible: false,
      isSelectorPresenterVisible: false,
      isSelectorPresenterDisabled: false,
      previewIndexChangeCounter: 0
    }
  },
  computed: {
    ...mapState(['currentPreviewIndex', 'cursorState', 'didShowSelectorPresenter', 'isContactModalOpen', 'previewBackgroundTexts']),
    isCursorAllowedToBeSelector () {
      return this.$route.name === 'portfolio' && !this.isContactModalOpen
    }
  },
  methods: {
    moveCursor (e) {
      const transformPosition = `translate(${e.clientX - 25}px, ${e.clientY - 25}px)`
      this.$refs.cursor.style.transform = transformPosition
      if (!this.didShowSelectorPresenter) this.$refs.presenter.style.transform = transformPosition
      if (this.cursorState !== 'selector') {
        if (!this.isSelectorStatic) this.$refs.selector.style.transform = transformPosition
        this.$refs.left.removeAttribute('style')
        this.$refs.right.removeAttribute('style')
      } else if (this.cursorState === 'selector' && !this.isSelectorStatic) {
        if (this.selectorOffset - e.clientX <= -73) {
          this.moveSelectorWhiteCircle()
          if (this.currentPreviewIndex < this.previewBackgroundTexts.length) this.$store.dispatch(this.$SET_CURRENT_PREVIEW, [this.currentPreviewIndex + 1, 'right'])
          this.dismissSelector()
        } else if (this.selectorOffset - e.clientX >= 73) {
          this.moveSelectorWhiteCircle()
          if (this.currentPreviewIndex > 1) this.$store.dispatch(this.$SET_CURRENT_PREVIEW, [this.currentPreviewIndex - 1, 'left'])
          this.dismissSelector()
        }
        this.$refs.indicator.style.transform = `translateX(${e.clientX - this.selectorOffset}px) scale(1)`
        this.$refs.left.style.transform = `translateX(${this.selectorOffset - e.clientX}px)`
        this.$refs.right.style.transform = `translateX(${this.selectorOffset - e.clientX}px)`
      }
    },
    moveSelectorWhiteCircle () {
      this.$store.dispatch(this.$SET_DID_SHOW_SELECTOR_PRESENTER)
      this.isSelectorPresenterVisible = false
      this.indicatorTransform = this.$refs.indicator.getAttribute('style')
      this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'default')
    },
    togglePreviewSelection () {
      if (this.isCursorAllowedToBeSelector) {
        this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'selector')
      }
    },
    dismissSelector () {
      this.$store.dispatch(this.$CHANGE_CURSOR_STATE, 'default')
      this.isSelectorStatic = true
      setTimeout(() => {
        this.$refs.indicator.removeAttribute('style')
        this.isSelectorStatic = false
      }, 200)
    },
    showSelectorPresenter () {
      if (this.hasRequirementsForShowingSelector()) {
        setTimeout(() => { this.isSelectorPresenterVisible = true }, 1000)
      }
    },
    hasRequirementsForShowingSelector () {
      return (this.previewIndexChangeCounter === TWO_PREVIEWS &&
        this.cursorState === 'default' &&
        !this.didShowSelectorPresenter &&
        this.isCursorAllowedToBeSelector)
    }
  },
  watch: {
    currentPreviewIndex () {
      this.previewIndexChangeCounter += 1
    },
    cursorState (cursor) {
      this.isSelectorPresenterDisabled = cursor === 'pointer'
      this.showSelectorPresenter()
    },
    previewIndexChangeCounter () {
      this.showSelectorPresenter()
    },
    isCursorAllowedToBeSelector () {
      this.isSelectorPresenterVisible = this.hasRequirementsForShowingSelector()
    }
  },
  mounted () {
    this.$root.$on('cursor-move', e => this.moveCursor(e))
    this.$root.$on('mouse-down', e => {
      if (this.cursorState === 'default' && this.isCursorAllowedToBeSelector) {
        this.isSelectorVisible = true
        this.selectorOffset = e.clientX
        this.togglePreviewSelection(e)
      }
    })
    this.$root.$on('mouse-up', () => {
      if (this.cursorState === 'selector') {
        this.isSelectorVisible = false
        this.dismissSelector()
      }
    })
  },
  comments: true
}
</script>
<style scoped lang="sass">
  @tailwind utilities

  /* purgecss start ignore */
  $cursor-dimension: 50px
  $transition-time: .2s

  .click-control
    @apply relative z-80 pointer-events-none

  .cursor
    @apply fixed pin-t pin-l rounded-full border-2 border-black
    width: $cursor-dimension
    height: $cursor-dimension
    will-change: transform
    @screen xl
      @apply block
    &__bg
      @apply absolute bg-grey-darkest rounded-full border-2 border-black opacity-10
      left: calc(50% - #{$cursor-dimension / 2})
      top: calc(50% - #{$cursor-dimension / 2})
      transition: opacity $transition-time
      width: $cursor-dimension
      height: $cursor-dimension
    &--pointer, &--text
      .cursor
        &__bg
          @apply opacity-100
      .target
        @apply opacity-0
    &--selector
      @apply opacity-0

  .selector
    @apply fixed pin-t pin-l z-80 flex opacity-0
    transition: opacity .2s
    height: $cursor-dimension
    &__left-corner
      @apply absolute pin-l rounded-l-full bg-grey-darkest
      width: $cursor-dimension / 2
      height: inherit
      transition: transform .4s
    &__right-corner
      @apply absolute rounded-r-full bg-grey-darkest
      left: $cursor-dimension / 2
      width: $cursor-dimension / 2
      height: inherit
      transition: transform .4s
    &__middle
      @apply absolute relative bg-grey-darkest
      right: $cursor-dimension
      width: $cursor-dimension * 3
      height: inherit
      transition: transform .4s
      transform: scaleX(0)
    &--visible
      @apply opacity-100
      .selector
        &__left-corner
          transform: translateX(-$cursor-dimension * 1.5)
        &__right-corner
          transform: translateX($cursor-dimension * 1.5)
        &__middle
          transform: scaleX(1.01)

  .selector-indicator
    @apply absolute bg-white z-50 rounded-full overflow-hidden
    top: 2.5px
    left: 2.5px
    width: $cursor-dimension - 5px
    height: $cursor-dimension - 5px

  .selector-item
    @apply absolute z-40 flex items-center justify-center text-4xl text-white opacity-0
    width: $cursor-dimension
    height: $cursor-dimension
    transition: opacity .3s .1s
    &--previous
      left: -$cursor-dimension * 1.5
    &--next
      left: $cursor-dimension * 1.5
    &--clipped
      @apply text-black opacity-100
      top: -2px
    &--visible
      @apply opacity-100
    &--disabled
      @apply opacity-0
    &--forbidden
      @apply text-white
      animation: fadeIn .1s .3s forwards

  .selector-item--clipped.selector-item--previous
    left: -$cursor-dimension * 1.5 - 3px

  .selector-item--clipped.selector-item--next
    left: $cursor-dimension * 1.5 - 3px

  .target
    @apply relative w-full h-full
    transition: opacity $transition-time
    &__x
      @apply absolute bg-white
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      width: 10px
      height: 2px
    &__y
      @apply absolute bg-white
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      width: 2px
      height: 10px

  .interaction-icon
    @apply absolute text-lg text-white opacity-0
    transition: opacity $transition-time
    top: 50%
    left: 50%
    transform: translate(-50%, -50%)
    &--visible
      @apply opacity-100

  .selector-feature-presenter
    @apply fixed w-56
    bottom: calc(100% + 3px)
    left: -6px
    transition: opacity .2s
    &--disabled
      @apply opacity-25

  .speech-bubble
    fill: none
    stroke: #575757
    stroke-width: 2px
    &__left
      $value: 225
      stroke-dasharray: $value
      stroke-dashoffset: $value
      transition: all .5s
      &--visible
        transition: all 1s
        stroke-dashoffset: 0
    &__right
      $value: 330
      stroke-dasharray: $value
      stroke-dashoffset: $value
      transition: all .5s
      &--visible
        transition: all 1s
        stroke-dashoffset: 0

  .presenter-text
    @apply absolute font-sans
    bottom: 25%
    left: 5%
    &__title
      @apply opacity-0
      transform: translateY(10px)
      transition: all .5s
      &--visible
        @apply opacity-100
        transform: none
    &__text
      @apply font-thin text-sm leading-tight opacity-0 mt-1
      transform: translateY(10px)
      transition: all .5s
      &--visible
        @apply opacity-100
        transform: none

  @keyframes fadeIn
    from
      @apply text-white
    to
      @apply text-red
  /* purgecss end ignore */
</style>
